(() => {
  if (customElements.get('hfa-better-together')) return;
  customElements.define('hfa-better-together',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.text=JSON.parse(this.querySelector('[data-bt-text]').textContent);
      this.money=new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency});
      this.button=this.querySelector('[data-bt-add]');
      this.status=this.querySelector('[data-bt-status]');
      this.onChange=()=>this.refresh();
      this.onAdd=()=>this.add();
      this.addEventListener('change',this.onChange);
      this.button.addEventListener('click',this.onAdd);
      this.refresh();
    }
    disconnectedCallback(){this.removeEventListener('change',this.onChange);this.button?.removeEventListener('click',this.onAdd);this.ready=false;}
    refresh() {
      const selected=this.querySelector('[data-bt-animal]')?.value;
      const panels=[...this.querySelectorAll('[data-bt-panel]')];
      panels.forEach((panel,index)=>panel.hidden=selected?panel.dataset.btPanel!==selected:index!==0);
      this.panel=panels.find(panel=>!panel.hidden);
      if(!this.panel){this.button.disabled=true;return;}
      this.picks=[...this.panel.querySelectorAll('[data-bt-pick]:checked:not(:disabled)')];
      const total=this.picks.reduce((sum,input)=>sum+Number(input.dataset.price),0);
      this.querySelector('[data-bt-total]').textContent=this.money.format(total/100);
      this.button.disabled=!this.picks.length||this.busy;
      if(!this.busy){this.button.textContent=this.text.add;this.status.textContent='';this.status.removeAttribute('data-error');}
    }
    async add() {
      if(this.busy||!this.picks.length)return;
      const items=this.picks.map(input=>({id:Number(input.dataset.variant),quantity:1}));
      this.busy=true;this.button.disabled=true;this.button.textContent=this.text.adding;this.status.textContent='';
      const root=window.Shopify?.routes?.root||'/';
      const drawer=document.querySelector('sugar-cart-drawer');
      const sections=drawer?.getSectionsToRender?.().map(section=>section.id)||[];
      try {
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
        const data=await response.json();
        if(!response.ok||data.status)throw Error(typeof data.description==='string'?data.description:this.text.error);
        this.status.textContent=this.text.added;
        try {
          if(drawer?.renderContents&&data.sections)drawer.renderContents(data);
          else if(drawer?.open)drawer.open();
          else {location.assign(root+'cart');return;}
        } catch {location.assign(root+'cart');return;}
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'hfa-better-together'}}));
      }catch(error){this.status.textContent=error.message||this.text.error;this.status.setAttribute('data-error','');}
      finally{this.busy=false;this.button.disabled=!this.picks.length;this.button.textContent=this.text.add;}
    }
  });
})();
